module.exports = __webpack_public_path__ + "static/media/7.3ef7b883.svg";